import { Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import { TextInput, minValue, maxValue, required } from "react-admin";

import MiqaatVenueLocationPicker from "./components/MiqaatVenueLocationPicker";
import { MIQAAT_VENUE_DEFAULT_RADIUS_METERS } from "./transform-miqaat-venue-payload";

function OptionalCoordInput({
  source,
  label,
  min,
  max,
}: {
  source: string;
  label: string;
  min: number;
  max: number;
}) {
  return (
    <TextInput
      source={source}
      label={label}
      fullWidth
      helperText="Filled by place search or pin; editable if needed"
      parse={(v) => (v === "" || v === undefined || v === null ? undefined : Number(String(v)))}
      format={(v) => (v === null || v === undefined || Number.isNaN(Number(v)) ? "" : String(v))}
      validate={[minValue(min), maxValue(max)]}
      slotProps={{
        htmlInput: { inputMode: "decimal" },
      }}
    />
  );
}

export default function MiqaatVenueFormFields({ isCreate = false }: { isCreate?: boolean }) {
  return (
    <>
      <TextInput source="name" label="Venue name" fullWidth validate={required()} />

      <Divider sx={{ my: 2 }} />
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Check-in location
      </Typography>
      <MiqaatVenueLocationPicker />
      <TextInput
        source="radiusMeters"
        label="Radius (meters)"
        fullWidth
        defaultValue={isCreate ? MIQAAT_VENUE_DEFAULT_RADIUS_METERS : undefined}
        helperText={`Self-scan acceptance radius (shown as a circle on the map). Default ${MIQAAT_VENUE_DEFAULT_RADIUS_METERS}m.`}
        parse={(v) => (v === "" || v === undefined || v === null ? undefined : Number(String(v)))}
        format={(v) => (v === null || v === undefined || Number.isNaN(Number(v)) ? "" : String(v))}
        validate={[minValue(1), maxValue(10000)]}
        slotProps={{
          htmlInput: { inputMode: "numeric" },
        }}
      />
      <OptionalCoordInput source="latitude" label="Latitude" min={-90} max={90} />
      <OptionalCoordInput source="longitude" label="Longitude" min={-180} max={180} />
    </>
  );
}
